import styled from "styled-components"
import React from "react"
import { Button } from "rsuite"
import branding, { LocalizedString } from "../../branding/branding"
import { useLanguageState } from "../../AppStrings"


const ErrorContentPanel = styled.div`
    min-width: 200px;
    max-width: 300px;
`

const ErrorImagePanel = styled.div`
    width: 100%;
    height: 300px;
    background: url("/emptyresult.jpg");
    background-size: cover;
`

const TitlePanel = styled.div`
    font-size: 20px;
    font-weight: bold;
    text-align: center;
`

const DescriptionPanel = styled.div`
    font-size: 14px;
    margin-top: 10px;
    text-align: center;
`

const ReloadButton = styled(Button)`
    margin-top: 45px;
    width: 100%;
    max-width: 300px;
    height: 40px;
    border-radius: 20px;
    background: linear-gradient(90deg, ${branding.loginRegistrationSite.loginBackgroundColor1} 0%, ${branding.loginRegistrationSite.loginBackgroundColor2} 100%);
    font-family: ${branding.font2};;
    font-size: 16px;
    letter-spacing: 0.3em;

    &:active {
        background: linear-gradient(90deg, ${branding.loginRegistrationSite.loginBackgroundColor1} 0%, ${branding.loginRegistrationSite.loginBackgroundColor2} 100%);
    }
`

export interface ErrorSiteBranding {
    reloadButton: LocalizedString
    errorTitle: LocalizedString
    errorDescription: LocalizedString
}

interface ErrorSiteProps {

}

const ErrorSite: React.FC<ErrorSiteProps> = (props) => {
    const languageState = useLanguageState()
    const strings = languageState.getStrings()

    function onReloadClicked() {
        window.location.reload();
    }
    return (
        <ErrorContentPanel>
            <ErrorImagePanel></ErrorImagePanel>
            <TitlePanel>{strings.errorSite.errorTitle}</TitlePanel>
            <DescriptionPanel>{strings.errorSite.errorDescription}</DescriptionPanel>
            <ReloadButton appearance="primary" onClick={onReloadClicked}>{strings.errorSite.reloadButton}</ReloadButton>
        </ErrorContentPanel>
    )

}


export default ErrorSite